import { useTranslation } from 'react-i18next';

export const keyPrefix = 'event_details_geolocation';
export const useEventDetailsGeolocationTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Локация',
    address_empty: 'Адрес отсутствует',
    longitude: 'Долгота',
    latitude: 'Широта',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Location',
    address_empty: 'No address',
    longitude: 'Longitude',
    latitude: 'Latitude',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Localização',
    address_empty: 'Endereço ausente',
    longitude: 'Longitude',
    latitude: 'Latitude',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Ubicación',
    address_empty: 'Dirección ausente',
    longitude: 'Longitud',
    latitude: 'Latitud',
  },
}) : {}) as Record<string, unknown>;
